import React, { useState } from 'react';
import  ReactVideoRecorder from 'react-video-recorder';
import Axios from 'axios';
import Swal from 'sweetalert2';
import { SaveCandidateRecordedVideo } from '../apiconstants/constants';

const VideoRecorderComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showWaitMessage, setShowWaitMessage] = useState(false);
  const [recordedVideoUrl, setRecordedVideoUrl] = useState(null);
  const [showThankYouMessage, setShowThankYouMessage] = useState(false);

  const handleRecordingComplete = async (videoBlob) => {
    const blobUrl = URL.createObjectURL(videoBlob);
    setRecordedVideoUrl(blobUrl);
    setShowWaitMessage(true);
    setIsLoading(false);

    try {
      const formData = new FormData();
      formData.append("guid", "6194e968-6e5d-41be-94ff-b474af120940");
      formData.append("videoUrl", blobUrl);
      formData.append("video", videoBlob, "recording.webm");

      const response = await Axios.post(
        SaveCandidateRecordedVideo.APIURL, // Replace with your API endpoint
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      );

      setIsLoading(false);

      if (response.status === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Video uploaded successfully",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          setShowThankYouMessage(true); // Show thank you message after success alert
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Failed to upload video",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (error) {
      console.error("Error uploading video: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during video upload",
        showConfirmButton: false,
        timer: 5000,
      });
      setIsLoading(false);
    }
  };

  return (
    <div>
      <ReactVideoRecorder
        onRecordingComplete={handleRecordingComplete}
        renderActions={({ startRecording, stopRecording }) => (
          <div>
            <button onClick={startRecording}>Start Recording</button>
            <button onClick={stopRecording}>Stop Recording</button>
          </div>
        )}
      />
      {recordedVideoUrl && (
        <div>
          <video
            src={recordedVideoUrl}
            controls
            autoPlay
            loop
            onLoadedMetadata={(e) => {
              const video = e.target;
              video.currentTime = 0; // Reset currentTime to 0
            }}
          />
        </div>
      )}
    </div>
  );
};

export default VideoRecorderComponent;
